
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navigate } from "react-router-dom";
import routes from './routes'; 
import Layout from './Layout'; 
import AuthService from '../services/AuthService'; // Your AuthService
import { toast } from 'react-toastify';

const getPermissions = () => {
    const storedPermissions = localStorage.getItem("permissions");
    return storedPermissions ? JSON.parse(storedPermissions) : [];
};

const AppRouter = () => {

    const isAuthenticated = AuthService.getCurrentUser();
    const permissions = getPermissions();
    const basePath= process.env.REACT_APP_BASE_PATH;

    return (
        <Router  basename={basePath} >
            <Routes>
                <Route path="/" element={<Navigate to="/dashboard" />} />
                {routes.map((route, index) => {
                    const Component = route.component;
                    // Check authentication and permissions
                    const requiresAuth = route.meta.requiresAuth;
                    let hasPermission = true;
                    if (route.meta.permission) {
                        hasPermission = permissions.includes(route.meta.permission);
                    }
                    const hideHeader = route.meta.hideHeader;

                    return (
                        <Route
                            key={index}
                            path={route.path}
                            element={
                                requiresAuth && !isAuthenticated ? (
                                    <Navigate to="/login" />
                                ) : (
                                    <Layout hideHeader={hideHeader} hasPermission={hasPermission} >
                                        <Component  />
                                    </Layout>
                                )
                            } 
                        />
                    );
                })}
            </Routes>
        </Router>
    );
};

export default AppRouter;
